import React from 'react';

import styles from './stacked-horizontal-bars-tile.module.scss';

type Segment = {
  label: string,
  value: number | null,
};

type Item = {
  label: string,
  value: number | null,
  segments: Segment[],
};

type Props = {
  title: string,
  items: Item[],
};

const segmentColorMap: Record<string, string> = {
  HU: '#007D8F',
  SU: '#31B7BC',
  Proxi: '#7CD4D9',
  'Non renseigné': '#C5D7DB',
};

export default function StackedHorizontalBarsTile({
  title,
  items,
}: Props) {
  const max = Math.max(...items.map((item) => item.value || 0), 0);
  const safeItems = items.length
    ? items
    : [{ label: '-', value: 0, segments: [{ label: 'HU', value: 0 }] }];

  return (
    <section className={styles.tile}>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.body}>
        {safeItems.map((item) => {
          const value = item.value || 0;
          const widthPct = max > 0 ? (value / max) * 100 : 0;

          return (
            <div key={item.label} className={styles.row}>
              <p className={styles.label}>{item.label}</p>
              <div className={styles.barLine}>
                <div
                  className={styles.barStack}
                  style={{ width: `${Math.max(widthPct, 2)}%` }}
                >
                  {item.segments.map((segment) => {
                    const segmentValue = segment.value || 0;
                    const segmentWidth = value > 0 ? (segmentValue / value) * 100 : 0;
                    return (
                      <div
                        key={`${item.label}-${segment.label}`}
                        className={styles.segment}
                        style={{
                          width: `${segmentWidth}%`,
                          backgroundColor: segmentColorMap[segment.label] || '#9FB7BC',
                        }}
                        title={`${segment.label}: ${segmentValue}`}
                      />
                    );
                  })}
                </div>
                <span className={styles.value}>{value}</span>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
